import { gql } from '@apollo/client';

export const BOOKING_DISCOUNT_CATEGORIES_QUERY = gql`
  query GetBookingDiscountCategoryIds {
    operativeViewer {
      bookingDiscountCategoryIds
    }
  }
`;

export const VENUE_BOOKINGS_ENABLED_QUERY = gql`
  query IsVenueBookingsEnabled {
    operativeViewer {
      bookingsEnabled
      defaultSeatingDurationMinutes
      baemingoChoiceEnabled
      autoAcceptBookings
    }
  }
`;

// Query to refetch bookings after status update
export const BOOKINGS_QUERY = gql`
  query GetBookings($venueId: ID!, $date: String!) {
    operativeViewer {
      bookingsForVenueAndDate(venueId: $venueId, date: $date) {
        id
        createdAt
        date
        startTime
        endTime
        comment
        status
        isManuallyAssigned
        tableIds
        guestName
        guestPhone
        guestEmail
        partySize
        chequeId
        discountPercent
      }
    }
  }
`;

export const INCOMING_BOOKINGS = gql`
  query GetIncomingBookings($venueId: ID!) {
    operativeViewer {
      incomingBookingsForVenue(venueId: $venueId) {
        id
        guestName
        guestEmail
        guestPhone
        discountPercent
        tableIds
        comment
        status
        createdAt
        date
        startTime
        endTime
        partySize
        discountPercent
      }
    }
  }
`;
